import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Navigation } from "./component/modern-navigation";
import SmoothScroll from "smooth-scroll";
import ScrollToTop from "./component/ScrollToTop";
import AppIndex from "./AppIndex";
import { useEffect, useState } from "react";
import { Footer } from "./component/mainFooterSection";
import { BlogHomepage, ProductsHomepage } from "./component/ProductsHomepage";
import { BlogPostDetail } from "./component/blogPostDetail";
import { Gallery } from "./component/galleryMainSection";
import { ProductGridmainSection } from "./component/productGridmainSection";
import { ProductDetail } from "./component/productDetail";
import { MaintenanceMode } from "./component/MaintenanceMode";
import { BookFreeSiteVisitSection } from "./component/BookFreeSiteVisitSection";
import { ProfessionalCollections } from "./component/professionalCollectionsSection";
import ConcreteMattPage from "./component/ConcreteMattPage";
import { ContactPage } from "./component/contactPage";
import LoadingAM from "./assets/rigve_loader.gif";
import CartPage from "./component/CartPage";
import Measurement from "./component/measurement";
import MeasurementTable from "./component/measurementTable";
import PartnerPage from "./component/PartnerPage";
// import PDFGenerator from "./component/PDFGenerator";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

function App() {
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("https://webadmin.rigve.com/api/get_extra_details")
      .then((res) => res.json())
      .then((data) => {
        if (data?.final === true || data?.final === "true") {
          setIsMaintenanceMode(true);
        } else {
          setIsMaintenanceMode(false);
        }
      })
      .catch((error) => {
        console.error("API fetch error:", error);

        // Force MaintenanceMode if API fails
        setIsMaintenanceMode(true);
      })
      .finally(() => setLoading(false));
  }, []);

  // Loading Screen
  if (loading) {
    return (
      <div className="text-center py-24 mt-50 w-[100%] min-h-[80vh] flex justify-center items-center">
        <img src={LoadingAM} className="w-[70px] h-[70px]" alt="Loading" />
      </div>
    );
  }

  // Maintenance Mode
  if (isMaintenanceMode) {
    return <MaintenanceMode />;
  }

  return (
    <Router>
      {/* Scroll to Top on Route Change */}
      <ScrollToTop />

      <div className="">
        <Navigation />

        <Routes>
          {/* Home */}
          <Route
            index
            element={
              <div className="App">
                <AppIndex />
              </div>
            }
          />

          <Route
            path="/App"
            element={
              <div className="App">
                <AppIndex />
              </div>
            }
          />

          {/* Products */}
          <Route
            path="/Products/:id/:name"
            element={<ProfessionalCollections />}
          />

          <Route
            path="/Product/:id/:page/:main_cat_id/:CategoryId/:name"
            element={<ConcreteMattPage />}
          />

          <Route
            path="/collections/:id/:main_cat_id"
            element={<ProductGridmainSection />}
          />

          {/* Gallery */}
          <Route path="/gallery" element={<Gallery />} />

          {/* Contact */}
          <Route
            path="/BookFreeSiteVisit"
            element={<BookFreeSiteVisitSection />}
          />

          <Route path="/contact" element={<ContactPage />} />

          {/* Partner */}
          <Route path="/partner" element={<PartnerPage />} />

          {/* Cart */}
          <Route path="/cart" element={<CartPage />} />

          {/* Blog */}
          <Route path="/blog/:id" element={<BlogPostDetail />} />

          {/* Measurement */}
          <Route path="/measurement" element={<Measurement />} />

          <Route path="/measurement/:id" element={<Measurement />} />

          <Route path="/measurementTabale" element={<MeasurementTable />} />

          {/* Optional */}
          {/* <Route path="/PDFGenerator" element={<PDFGenerator />} /> */}
        </Routes>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
